module.exports = __webpack_public_path__ + "img/DK25802888.e8e1638f.png";